import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "../../../utilis/api";
import { useDispatch, useSelector } from "react-redux";
import { update } from "../../../redux/store/userSlice";

const Edit = ({ userData, onSave }) => {
  const [user, setUser] = useState(userData);
  const { token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };
  console.log(token);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put(
        `/auth/update/${user._id}`, // URL
        user, // 1️⃣ Request body with updated user info
        {
          headers: {
            Authorization: `Bearer ${token}`, // 2️⃣ Attach token here
          },
        },
      );

      if (res.data?.meta?.success) {
        toast.success(res.data.meta.message || "User updated successfully", {
          autoClose: 2000,
        });
        console.log(res.data.data);
        dispatch(update(res.data.data));
      } else {
        toast.error(res.data?.meta?.message || "User update failed", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div>
        <label className="block mb-1 font-medium">Name</label>
        <input
          type="text"
          name="name"
          value={user?.name}
          onChange={handleChange}
          className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Email</label>
        <input
          type="email"
          name="email"
          value={user?.email}
          onChange={handleChange}
          className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Phone</label>
        <input
          type="tel"
          name="phone"
          value={user?.phone}
          onChange={handleChange}
          className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="submit"
          className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all duration-300"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default Edit;
